import * as geo from '@uhaulcom/shared/layout/geo.js';

geo.setCurrentLocationGetter("useDeviceLocation_Refill", "searchAddress_Refill");
geo.setCurrentLocationGetter("useDeviceLocation_AltFuel", "searchAddress_AltFuel");
geo.setCurrentLocationGetter("useDeviceLocation_Delivery", "CheckAvailabilityPostalCode");
